import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '@env/environment';
import {PaymentMethod, PaymentMethodFiltro} from '@app/domain/payment-method';
import {Page} from '@app/domain/page';


@Injectable({
    providedIn: 'root'
})
export class PaymentMethodService {

    baseUrl: string = environment.endpointApi;

    constructor(private http: HttpClient) {
    }

    findAll(filtro: PaymentMethodFiltro = {}): Observable<PaymentMethod[]> {
        return this.http.get<PaymentMethod[]>(`${this.baseUrl}/payment-methods`, {params: this.toParams(filtro)});
    }

    findAllPage(filtro: PaymentMethodFiltro, pageNumber: number, perPage: number,
                sortField?: string, sortOrder?: number): Observable<Page<PaymentMethod>> {
        let params = this.toParams(filtro)
            .set('pageNumber', String(pageNumber))
            .set('perPage', String(perPage));
        if (sortField && sortOrder) {
            params = params.set('sortField', sortField).set('sortOrder', String(sortOrder));
        }
        return this.http.get<Page<PaymentMethod>>(`${this.baseUrl}/payment-methods`, {params});
    }

    private toParams(filtro: PaymentMethodFiltro): HttpParams {
        let params = new HttpParams();
        Object.keys(filtro).filter(key => filtro[key]).forEach(key => params = params.set(key, filtro[key]));
        return params;
    }

    findById(id): Observable<PaymentMethod> {
        return this.http.get(`${this.baseUrl}/payment-methods/${id}`);
    }

    save(model: PaymentMethod): Observable<PaymentMethod> {
        return this.http.post<PaymentMethod>(`${this.baseUrl}/payment-methods`, model);
    }

    edit(id, model: PaymentMethod): Observable<PaymentMethod> {
        return this.http.put<PaymentMethod>(`${this.baseUrl}/payment-methods/${id}`, model);
    }

    delete(id): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/payment-methods/${id}`);
    }
}
